"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var social_networks_1 = tslib_1.__importStar(require("../../../../constants/social-networks"));
var build_url_1 = require("../../../../../common/utils/url/build-url");
var get_origin_1 = require("../../../../../common/utils/url/get-origin");
var open_popup_1 = tslib_1.__importDefault(require("../../../../../common/utils/open-popup"));
var utils_1 = require("../utils");
var tooltip_1 = tslib_1.__importDefault(require("../../../../ui-components/tooltip/tooltip"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../ui-components/inline-icon/inline-icon"));
var styles_scss_1 = tslib_1.__importDefault(require("../styles.scss"));
var FacebookIcon_1 = tslib_1.__importDefault(require("../../../../../icons/compiled/components/FacebookIcon"));
var Facebook = /** @class */ (function (_super) {
    tslib_1.__extends(Facebook, _super);
    function Facebook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var canShareContent = _this.props.canShareContent;
            if (canShareContent) {
                var url = _this.getShareUrl();
                (0, open_popup_1.default)(url);
            }
            _this.props.onShare(social_networks_1.default.FACEBOOK);
        };
        return _this;
    }
    Facebook.prototype.getShareUrl = function () {
        var _a = this.props, instanceInfo = _a.instanceInfo, videoId = _a.videoId, channelId = _a.channelId;
        var instanceId = instanceInfo.instanceId, componentId = instanceInfo.componentId, sitePageId = instanceInfo.sitePageId, siteUrl = instanceInfo.siteUrl, biToken = instanceInfo.biToken;
        var baseUrl = (0, get_origin_1.getOrigin)(siteUrl);
        var shareProxyUrl = (0, build_url_1.buildUrl)("".concat(baseUrl, "/").concat(social_networks_1.shareMappingPath, "/").concat(sitePageId), {
            'instance-id': instanceId,
            'component-id': componentId,
            'channel-id': channelId,
            'video-id': videoId,
            'bi-token': biToken,
            bsi: (0, utils_1.getBsi)(),
        });
        return (0, build_url_1.buildUrl)('https://www.facebook.com/sharer/sharer.php', {
            ref: 'site',
            display: 'popup',
            u: shareProxyUrl,
        });
    };
    Facebook.prototype.render = function () {
        var _a = this.props, className = _a.className, ariaLabel = _a.ariaLabel, dataHook = _a.dataHook, tooltip = _a.tooltip;
        return (react_1.default.createElement(tooltip_1.default, { content: tooltip },
            react_1.default.createElement("button", { onClick: this.onClick, "data-hook": dataHook, className: className, "aria-label": ariaLabel },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(FacebookIcon_1.default, null), className: styles_scss_1.default.icon }))));
    };
    Facebook.propTypes = {
        dataHook: prop_types_1.default.string,
        onShare: prop_types_1.default.func,
        className: prop_types_1.default.string,
        canShareContent: prop_types_1.default.bool,
        tooltip: prop_types_1.default.node,
        videoId: prop_types_1.default.string,
        channelId: prop_types_1.default.string,
        instanceInfo: prop_types_1.default.shape({
            instanceId: prop_types_1.default.string,
            componentId: prop_types_1.default.string,
            sitePageId: prop_types_1.default.string,
            siteUrl: prop_types_1.default.string,
        }),
        ariaLabel: prop_types_1.default.string,
    };
    Facebook.defaultProps = {
        onShare: lodash_1.noop,
    };
    return Facebook;
}(react_1.default.Component));
exports.default = Facebook;
//# sourceMappingURL=facebook.js.map